import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_user_profile_form_modal = _resolveComponent("user-profile-form-modal")!
  const _component_role_in_school_select_modal = _resolveComponent("role-in-school-select-modal")!
  const _component_roles_in_classes_modal = _resolveComponent("roles-in-classes-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Update your information")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment, {
                    mode: "ios",
                    modelValue: _ctx.selectedSection,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSection) = $event)),
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "personal" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode(" Your personal information ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, { value: "school" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" Your position(s) in the school ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, { value: "class" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Your role(s) in class(es) ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_user_profile_form_modal, { hideHeader: true })
          ], 512), [
            [_vShow, _ctx.selectedSection == 'personal']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_role_in_school_select_modal, {
              hideHeader: true,
              selectedRolesInSchool: _ctx.selectedRolesInSchool
            }, null, 8, ["selectedRolesInSchool"])
          ], 512), [
            [_vShow, _ctx.selectedSection == 'school']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_roles_in_classes_modal, {
              hideHeader: true,
              prefilledRolesInClasses: _ctx.prefilledRolesInClasses
            }, null, 8, ["prefilledRolesInClasses"])
          ], 512), [
            [_vShow, _ctx.selectedSection == 'class']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}